import React from 'react';

const CONTACT_US_URL = 'https://myyogateacher.com/contactus';

// PDF-only closing card — https://www.figma.com/design/tEh3nGLKULPHQ3KgQFSciK/Personalised-Plan?node-id=4858-248
const GetInTouch: React.FC = () => (
  <div className="w-full flex justify-center mt-[25px]">
    <div
      data-pdf-section
      data-pdf-force-page-break
      className="w-full bg-[#F9F9F9] rounded-[20px] py-[50px] px-[40px] flex flex-col items-center gap-[24px]"
    >
      <p className="text-center text-[22px] leading-[28px] font-Inter font-[550] m-0">
        <span className="text-[#232323]">Still have Questions? </span>
        <br />
        <span className="text-[#EE731B]">Get in touch</span>
      </p>
      {/* No box-shadow here — html2canvas renders drop shadows on rounded-corner
          elements incorrectly (the blurred halo bleeds asymmetrically past the
          bottom/side corners), making an otherwise uniform rounded-[10px] button
          look melted/lopsided once rasterised into the PDF. */}
      {/* Not a real <a> — the rasterised PDF page can never make a native anchor
          clickable anyway. The actual clickable region is a pdf.link() annotation
          overlaid afterwards by downloadPersonalisedPlanPdf.ts, which reads the
          target URL from data-pdf-cta-url (same pattern as data-pdf-teacher-link
          in NotesFromCoach). */}
      <div
        data-pdf-cta-link
        data-pdf-cta-url={CONTACT_US_URL}
        className="flex items-center justify-center bg-[#EE731B] rounded-[10px] px-[12px] pt-2 pb-5 text-center text-white text-[10px] font-Inter font-[550] leading-[13px] whitespace-nowrap"
      >
        Speak to the team
      </div>
    </div>
  </div>
);

export default GetInTouch;
